import App from "@frog/source/models/App.js"
import Tiled from "@frog/source/utility/integration/Tiled.js"
import Random from "@frog/source/utility/Random.js"
import Audiomix from "@frog/source/juice/Audiomix.js"
import * as PlotSteps from "@frog/source/data/plot/steps.js"
import * as PlotConditions from "@frog/source/data/plot/conditions.js"
import * as PlotScripts from "@frog/source/data/plot/scripts.js"
import Navigation from "@frog/source/models/Navigation.js"
import Zone from "@frog/source/models/Zone.js"
import Step from "@frog/source/models/Step.js"

const TURN_COUNT = 8
const PROTOUNIT = {
    "randomJobKey": "sword,dagger,bow,spear",
    "affiliation": "bad",
    // ai?
}
const world = Tiled.parse({
    "tilemap": require("./tiles.json"),
    "tileset": require("@frog/source/data/levels/vmenezio.tileset.json"),
})
world.spots = require("./spots.json")

export default {
    "slug": "y1",
    "stage": {
        "image": require("./tiles.png"),
        "units": require("./units.json"),
        "world": world,
        "text": function(stage) {
            const currentTurnNumber = stage.turn.number + (stage.turn.phase == "end" ? 1 : 0)
            if(currentTurnNumber < TURN_COUNT) {
                const roundsRemaining = Math.max(0, Math.ceil((TURN_COUNT - currentTurnNumber) / 2))
                return "Defend for " + roundsRemaining + " round" + (roundsRemaining != 1 ? "s" : "")
            } else {
                return "Defeat all enemies"
            }
        },
        "conditions": [
            {
                "type": "turn:0:start",
                "events": [
                    "Title: Chapter Oof / The Plains / In which the princess gets rolled / and we cry",
                    PlotSteps.PlayAudio("Music:Combat"),
                    PlotSteps.SpawnPlayerPartyScript(),
                    "Ruffian: Your valuables or your lives!",
                    PlotSteps.ifFlagsMeetCondition((flags) => (flags.friend_here == true && flags.princess_here == true), [
                        "FRIEND: damn.",
                        "PRINCESS: woah.",
                        "RUFFIAN: yeah, even I think that's messed up.",
                    ]),
                    PlotSteps.ifFlagsMeetCondition((flags) => (flags.friend_here == true), [
                        Step.deltastage({"camera": {"unitKey": "friend"}}),
                        PlotSteps.Wait(300),
                        "FRIEND: Look at all this grass. All for me...",
                        Step.deltastage({"unit": {"key": "friend", "affiliation": "bad"}}),
                        "YOUR FRIEND HAS MUTINIED",
                        Step.deltastage({"camera": {"unitKey": null}}),
                    ]),
                    `Princess: Quite the conundrum, eh Mark?
                        - Fight -> bandit_tactic=wrong
                        - Fight like hell -> bandit_tactic=right`,
                ]
            },
            {
                "type": "turn:1:end",
                "events": [

                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                ]
            },
            {
                "type": "turn:3:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                ]
            },
            {
                "type": "turn:5:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                ]
            },
            {
                "type": "turn:7:end",
                "events": [
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                    PlotSteps.SpawnUnitAtSpot({"spotTag": "spawn", "protounit": PROTOUNIT}),
                ]
            },
            {
                "type": "condition",
                "condition": (stage) => {
                    return stage.turn.number > TURN_COUNT
                        && PlotConditions.areAllUnaffiliatedUnitsDefeated(stage, {"affiliation": "good"})
                },
                "events": [
                    (stage) => {
                        return {
                            "name": "SavestateCapture",
                            "savestateSlug": "winChapter_" + stage.chapterSlug,
                        }
                    },
                    PlotSteps.ChapterSuccessClassic(),
                    {"func": () => Navigation.go("/games/war/chapters/y2")}, // GO TO OVERWORLD INSTEAD
                ]
            },
            PlotScripts.ChapterFailure(),
        ]
    },
}
